<template>
  <div class="root main-banner" :class="{ 'has-illustration': hasIllustration }">
    <!-- <v-dialog
      v-model="dialog"
      max-width="690">
      <v-card class="video-popup">
        <v-card-title class="headline">
          <h2 class="title">
            {{ $t('Amazing acompany deserve') }}
            <v-btn icon @click="handleVideoClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </h2>
        </v-card-title>
        <div class="text-center" v-if="yt.use">
          <youtube
            :video-id="videoId"
            :player-vars="playerVars"
            :width= "640"
            :height="360"
            ref="youtube"
          />
        </div>
      </v-card>
    </v-dialog> -->
    <!-- <div class="decoration">
      <svg class="left-deco">
        <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-left.svg#main'" />
      </svg>
      <svg class="right-deco">
        <use :xlink:href="ASSETS_URL + 'images/saas/deco-bg-right.svg#main'" />
      </svg>
    </div> -->
    <v-container :class="{ fixed: isDesktop }">
      <div class="slider-wrap">
        <div class="text" :style="hasIllustration ? null : 'max-width:100% !important'">
          <slot>
            <h3 class="use-text-title" :class="{ 'text-center': hasIllustration }">
              <span v-html="$t('copy.banner.headline')" />
            </h3>
            <p class="use-text-subtitle">
              <span v-html="$t('copy.banner.subtitle')" />
            </p>
          </slot>
          <div class="btn-area">
            <!-- <v-btn
              text
              class="play-btn"
              @click="handleVideoOpen()"
            >
              <span class="icon">
                <i class="ion-ios-play-outline" />
              </span>
              {{ $t('Watch Video') }}
            </v-btn> -->
            <v-btn :to="link.saas.register" color="secondary" x-large class="px-10">
              <span v-t="'Get Started'" />
            </v-btn>
          </div>
        </div>
        <div v-if="hasIllustration" class="illustration">
          <img :src="true ? ASSETS_URL + imgAPI.saas[7] : imgAPI.saas[8]" alt="illustration" />
        </div>
      </div>
    </v-container>
    <div class="deco">
      <hidden point="mdDown">
        <div :class="{ hide: hide }" class="deco-inner">
          <div class="wave wave-one" />
          <div class="wave wave-two" />
        </div>
      </hidden>

      <div class="wave wave-cover" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./banner-style.scss";
</style>

<script>
// import youtube from '@/landing/youtube'
import imgAPI from "@/landing/static/images/imgAPI";
import link from "@/landing/static/text/link";
// import Hidden from '../Hidden'

export default {
  //   components: {
  //     Hidden
  //   },
  data() {
    return {
      hasIllustration: false,
      videoId: "KxZAdEGpYAw",
      hide: false,
      link: link,
      imgAPI: imgAPI,
      dialog: false,
      player: null,
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 1,
        mute: 0,
        origin: "https://localhost:8008",
      },
      //   yt: youtube
    };
  },
  methods: {
    handleVideoOpen() {
      //   if (!this.yt.use) {
      //     return false
      //   }
      this.dialog = true;
      setTimeout(() => {
        this.player = this.$refs.youtube.player;
        this.player.playVideo();
      }, 100);
    },
    handleVideoClose() {
      this.dialog = false;
      this.player.pauseVideo();
    },
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
      //   const lgUp = this.$store.state.breakpoints.lgUp
      //   return lgUp.indexOf(this.$mq) > -1
    },
  },
};
</script>
